import {Epic} from 'redux-observable'
import {kostAuswertungCFDefResponseAction, kostAuswertungModalOpenAction} from 'module/Kost/action/KostAction'
import {filter, from, mergeMap} from 'rxjs'
import {fetchKostAuswertungCFDefs} from 'module/CustomField/api/CustomFieldAPI'
import {catchServerError} from 'module/ConfirmDialog/component/ConfirmDialogContainer'

let fetched = false

export const KostAuswertungCFDefsEpic: Epic = (action$, state$) => action$.pipe(
	filter(kostAuswertungModalOpenAction.match),
	mergeMap(() => {
		if (fetched) return []
		return from(fetchKostAuswertungCFDefs()).pipe(
			mergeMap(({data: cfDefs}) => {
				fetched = true
				if (!cfDefs) return []
				return [kostAuswertungCFDefResponseAction(cfDefs)]
			}),
			catchServerError(),
		)
	}),
)